import { render, staticRenderFns } from "./evasion.vue?vue&type=template&id=52dcc2b6&scoped=true"
import script from "./evasion.vue?vue&type=script&lang=js"
export * from "./evasion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcc2b6",
  null
  
)

export default component.exports